<template>
  <div>
    <div class="elevation-1 rounded pa-5 white">
      <v-row class="align-center">
        <v-col md="auto">
          <div class="d-flex align-center mb-3">
            <h1 class="secondary--text">
              {{ order.id }}
            </h1>
            <OrderIconsField
              :order="order"
              :showPrintableInfo="true"
              :showDistributedInfo="true"
              :showGroupOrderInfo="true"
              :showClaimInfo="false"
              :showArchiveOrder="true">
            </OrderIconsField>
            <v-btn
              v-if="order.inquiries && order.inquiries.length"
              @click="navInquiries(order.inquiries)"
              class="ml-2"
              small
              color="accent">
              HAS CLAIM TICKET
            </v-btn>
          </div>
          <div class="caption secondary--text">
            Created at
            <code class="text-caption"
              >{{ order.created | getOnlyDate }} {{ order.created | getOnlyTime }} (GMT+{{ getGmtDiff }})</code
            >
            by
            <code class="text-caption">
              {{ order.seller.user.fullName ?? order.seller.user.name }}
            </code>
          </div>
          <OrderExpirationExtender :order="order" @order-updated="$emit('order-updated', $event)" />
        </v-col>
        <v-spacer></v-spacer>

        <!-- Payment Method -->
        <template v-if="paymentMethodData">
          <v-col cols="auto" class="ma-0 d-flex flex-column align-center justify-end">
            <img
              v-bind="attrs"
              v-on="on"
              :src="paymentMethodData.icon"
              :alt="paymentMethodData.description"
              width="24"
              class="mr-2 ml-2"
              style="border-radius: 4px" />
            <div class="text-caption mt-1">Debited via {{ paymentMethodData.description }}</div>
          </v-col>

          <v-divider class="ml-3 mr-3 mb-5 mt-5" inset vertical />
        </template>

        <!-- These slots for validation systems. -->
        <slot name="default"></slot>
        <slot name="dialog"></slot>
        <v-col md="auto">
          <h3 class="warning--text text--lighten-1">
            {{ order.cancelInformation.amount.plainText }}
          </h3>
          <div class="text-caption">Refunded order amount</div>
        </v-col>

        <v-col md="auto">
          <h3>
            {{ order.calculatedPrice.total.plainText }}
          </h3>
          <div class="text-caption">Total order amount</div>
        </v-col>

        <v-col md="auto">
          <h3 :class="[order.calculatedPrice.balance.amount < 0 ? 'red--text' : 'green--text']">
            {{ order.calculatedPrice.balance.plainText }}
          </h3>
          <div class="text-caption">Order payment balance</div>
        </v-col>
      </v-row>
    </div>

    <ExternalBookingSummary :bookings="order.bookings" :tenant-name="order.seller.tenant.name" />
  </div>
</template>

<script>
import { copyToClipboard, fixUrl } from "@/util/helpers";
import toolbarTitle from "@/components/common/toolbarTitle";
import OrderIconsField from "@/components/common/OrderIconsField";
import common from "@/mixins/common";
import moment from "moment";
import ExternalBookingSummary from "./externalBookingSummary.vue";
import OrderExpirationExtender from "@/components/common/OrderExpirationExtender";

export default {
  components: {
    OrderIconsField,
    toolbarTitle,
    copyToClipboard,
    ExternalBookingSummary,
    OrderExpirationExtender,
  },
  mixins: [common],
  computed: {
    getGmtDiff() {
      return moment().utcOffset() / 60;
    },
    paymentMethodData() {
      const paymentInfo = this.order.paymentInfo;

      if (!paymentInfo || !paymentInfo.system) {
        return null;
      }

      switch (paymentInfo.system) {
        case "swish":
          return {
            icon: require("@/assets/payments/swish.svg"),
            description: paymentInfo.method ? `Swish (${paymentInfo.method})` : "Swish",
          };
        case "klarna":
          return {
            icon: require("@/assets/payments/klarna.svg"),
            description: paymentInfo.method ? `Klarna (${paymentInfo.method})` : "Klarna",
          };
        case "card":
          return {
            icon: require("@/assets/payments/card.svg"),
            description: "card",
          };
        case "fortnox":
          return {
            icon: require("@/assets/payments/invoice.jpeg"),
            description: paymentInfo.method ? `Fortnox (${paymentInfo.method})` : "Fortnox",
          };
        case "free":
          return {
            icon: "https://assets.trainplanet.com/wlabel/trainplanet/logos/favicon-32x32.png",
            description: "Free",
          };
        default:
          return null;
      }
    },
  },
  filters: {
    humanDatetime(datetime) {
      return moment.utc(datetime).local().fromNow();
    },
    getOnlyDate(datetime) {
      return moment.utc(datetime).local().format("YYYY-MM-DD");
    },
    getOnlyTime(datetime) {
      // get gmt offset
      return moment.utc(datetime).local().format("HH:mm");
    },
  },
  methods: {
    navInquiries(value) {
      window.open("/orders/inquiries/" + value);
    },
    copyToClipboard,
    fixUrl,
  },
  props: {
    order: [],
  },
};
</script>
